import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-138515a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pipeline-banner" }
const _hoisted_2 = { class: "pipeline-text" }
const _hoisted_3 = { class: "wow animate__fadeInBottomRight" }
const _hoisted_4 = { class: "wow animate__fadeInDownBig" }

import 'element-plus/theme-chalk/display.css'
import { nextTick, onMounted, ref, watch } from 'vue'
import { useWindowSize } from '@/views/Product/ProductPipeline/useWindowSize'
import WOW from 'wow.js'
// 是否改变研发产品管线盒子顺序

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isEnd = ref(false)
const size = useWindowSize()

onMounted(() => {
    new WOW().init()
})
watch(size, (val) => {
    if (val.width < 768) {
        isEnd.value = true
    } else {
        isEnd.value = false
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('Focus on health1')), 1),
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('Focus on health')), 1)
    ])
  ]))
}
}

})